/**
 * When a `createAction` or `signAction` is completed in undelayed mode (`acceptDelayedBroadcast`: false),
 * any unsucccessful result will return the results by way of this exception to ensure attention is
 * paid to processing errors.
 */
export class WERR_REVIEW_ACTIONS extends Error {
    reviewActionResults;
    sendWithResults;
    txid;
    tx;
    noSendChange;
    code;
    isError = true;
    /**
     * All parameters correspond to their comparable `createAction` or `signSction` results
     * with the exception of `reviewActionResults`;
     * which contains more details, particularly for double spend results.
     */
    constructor(reviewActionResults, sendWithResults, txid, tx, noSendChange) {
        super('Undelayed createAction or signAction results require review.');
        this.reviewActionResults = reviewActionResults;
        this.sendWithResults = sendWithResults;
        this.txid = txid;
        this.tx = tx;
        this.noSendChange = noSendChange;
        this.code = 5;
        this.name = this.constructor.name;
    }
}
export default WERR_REVIEW_ACTIONS;
//# sourceMappingURL=WERR_REVIEW_ACTIONS.js.map